import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @description 自定义Modal组件
 * @author Jacky
 * @date 2025-08-09
 */
import { useEffect, useState } from "react";
import { Modal } from "antd";
import Style from "./index.module.less";
import Providers from "@/providers/AntdProvider";
// 自定义Modal组件
const CModal = ({ children, content, ...props }) => {
    const { open, onCancel, onOk, width, footer, showCancel = true, maskClosable = false, ...rest } = props;
    const [isOpen, setIsOpen] = useState(open ?? false);
    // 同步外部 open 状态
    useEffect(() => {
        setIsOpen(open ?? false);
    }, [open]);
    // 处理取消事件
    const handleCancel = (e) => {
        setIsOpen(false);
        onCancel?.(e);
    };
    // 处理确定事件
    const handleOk = (e) => {
        setIsOpen(false);
        onOk?.(e);
    };
    // 渲染Modal组件 使用antd的Modal组件，并添加自定义样式
    return (_jsx(Providers, { children: _jsx(Modal, { styles: {
                content: { padding: "32px", borderRadius: "16px" },
                footer: { marginTop: "26px" },
            }, ...rest, open: isOpen, width: width ?? 520, className: Style["c-modal"], transitionName: "", maskTransitionName: "", maskClosable: maskClosable, footer: footer !== undefined
                ? footer
                : (_, { OkBtn, CancelBtn }) => (_jsxs(_Fragment, { children: [showCancel && _jsx(CancelBtn, {}), _jsx(OkBtn, {})] })), onCancel: handleCancel, onOk: handleOk, children: content ?? children }) }));
};
CModal.displayName = "CModal";
export default CModal;
// 导出 API（用于 message 风格的调用）
export { modal, bModal } from "./api";
